import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const ResetReportButton = ({
  onReset,
  disabled,
  tooltipText
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: tooltipText,
  children: /*#__PURE__*/_jsx(Button, {
    onClick: onReset,
    disabled: disabled,
    use: "transparent",
    size: 'small',
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.reset.label"
    })
  })
});